var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellRinging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bell-ringing-03"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M15.0002 19.5C15.0002 21.1569 13.6571 22.5 12.0002 22.5C10.3434 22.5 9.00025 21.1569 9.00025 19.5M13.7968 6.73856C14.2322 6.28864 14.5002 5.67562 14.5002 5C14.5002 3.61929 13.381 2.5 12.0002 2.5C10.6195 2.5 9.50025 3.61929 9.50025 5C9.50025 5.67562 9.76825 6.28864 10.2037 6.73856M2.54707 8.82296C2.53272 7.37161 3.3152 6.01631 4.57928 5.30306M21.4534 8.82296C21.4678 7.37161 20.6853 6.01631 19.4212 5.30306M18.0002 11.7C18.0002 10.3209 17.3681 8.99823 16.2429 8.02304C15.1177 7.04786 13.5915 6.5 12.0002 6.5C10.4089 6.5 8.88283 7.04786 7.75761 8.02304C6.63239 8.99823 6.00025 10.3209 6.00025 11.7C6.00025 13.9818 5.43438 15.6506 4.72831 16.8447C3.92359 18.2056 3.52122 18.8861 3.53711 19.0486C3.55529 19.2346 3.58876 19.2933 3.73959 19.4036C3.87142 19.5 4.53376 19.5 5.85844 19.5H18.1421C19.4667 19.5 20.1291 19.5 20.2609 19.4036C20.4117 19.2933 20.4452 19.2346 20.4634 19.0486C20.4793 18.8861 20.0769 18.2056 19.2722 16.8447C18.5661 15.6506 18.0002 13.9818 18.0002 11.7Z",
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellRinging);
export default __webpack_public_path__ + "static/media/bell-ringing.51a42ccda76f80ec777cfec27b0043ca.svg";
export { ForwardRef as ReactComponent };